<script>
import _ from 'lodash'
import SkeletonLoader from '@components/skeleton-loader.vue'

export default {
  components: { SkeletonLoader },
  inheritAttrs: false,
  model: {
    event: 'update',
  },
  props: {
    emptyText: {
      type: String,
      default: '',
    },
    options: {
      type: [Object, Array],
      required: true,
    },
    optionValue: {
      type: [String, Number],
      default: '',
    },
    optionText: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
      default: '',
    },
    error: {
      type: String,
      default: '',
    },
    changed: {
      type: Boolean,
    },
    loading: {
      type: Boolean,
    },
    changedColor: {
      type: String,
      default: '#FFEDE1',
    },
  },
  computed: {
    optionType() {
      const options = _.toArray(this.options)
      return typeof _.head(options)
    },
    isObjectOption() {
      return this.optionType === 'object'
    },
    isStringOption() {
      return this.optionType === 'string'
    },
    isNumberOption() {
      return this.optionType === 'number'
    },
  },
}
</script>

<template>
  <div class="position-relative">
    <div v-if="loading">
      <SkeletonLoader style="width: 100%; height: 40px" />
    </div>
    <select
      v-else
      :style="{ background: changed ? changedColor : '#fff' }"
      :class="$style.select"
      v-bind="$attrs"
      @input="$emit('update', $event.target.value)"
      v-on="$listeners">
      <option v-if="emptyText" :class="{ [$style.gray]: true }" value="">{{ emptyText }}</option>
      <template v-if="isObjectOption">
        <option
          v-for="option in options"
          :key="option[optionValue]"
          :value="option[optionValue]"
          :selected="option[optionValue] === value"
          >{{ option[optionText] }}</option
        >
      </template>
      <template v-if="isStringOption || isNumberOption">
        <option v-for="option in options" :key="option" :value="option" :selected="option === value"
          >{{ option }}
        </option>
      </template>
    </select>
    <BaseIcon v-if="!loading" name="chevron-down" :class="$style.selectDownArrow" />
    <div :class="$style.errorContainer">
      <p v-if="error" :class="$style.errorMessage" class="tag-text">{{ error }}</p>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.select {
  width: 100%;
  height: 40px;
  padding: 8px 45px 10px 16px;
  font-size: 16px;
  color: $dark-gray;
  cursor: pointer;
  background-color: $white;
  border: 0.5px $primary-blue solid;
  border-radius: 36px;
  outline: none;
  appearance: none;
}

.errorMessage {
  @extend %error-message;

  text-align: center;
}

.errorContainer {
  position: absolute;
  right: 0;
  left: 0;
}
.selectDownArrow {
  position: absolute;
  top: 12px;
  right: 18px;
  color: $gray;
  pointer-events: none;
}
</style>
